import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import RecentReviews from "@/components/Home/RecentReviews";
import { fontFamily } from "@/styles/font";

// Styled Components
const Container = styled.div`
    position: relative;
    width: 100%;
    max-width: 393px;
    height: 100%;
    background: #ffffff;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    flex: 1;
    padding: 0 16px;
    box-sizing: border-box;
    overflow-y: auto;
`;

const SearchBarContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 8px 8px 4px;
    gap: 4px;
    width: 100%;
    height: 56px;
    background: #ffffff;
`;

const SearchField = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px;
    gap: 4px;
    width: 100%;
    height: 40px;
    background: #f9f9f9;
    border-radius: 12px;
    cursor: pointer;
`;

const SearchIcon = styled.img`
    width: 24px;
    height: 24px;
    flex: none;
`;

const SearchPlaceholder = styled.div`
    font-family: ${fontFamily.base};
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #a4adb2;
    flex: 1;
`;

const LogoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    width: 100%;
    margin-bottom: 32px;
`;

const Logo = styled.div`
    width: 138px;
    height: 87px;
    background: url("/images/soolmoa_logo.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
`;

const Home: React.FC = () => {
    const navigate = useNavigate();

    const handleSearchClick = () => {
        navigate("/search");
    };

    return (
        <Container>
            <ContentWrapper>
                <SearchBarContainer>
                    <SearchField onClick={handleSearchClick}>
                        <SearchIcon src="/icon/search.png" alt="검색" />
                        <SearchPlaceholder>검색어를 입력해주세요</SearchPlaceholder>
                    </SearchField>
                </SearchBarContainer>

                <LogoContainer>
                    <Logo />
                </LogoContainer>

                <RecentReviews />
            </ContentWrapper>
        </Container>
    );
};

export default Home;
